import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsPedidosClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getPedidos(queries = {}) {
    try {
      return await this.api.get('/pedidos', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic-item ');
    }
  }

  async postPedidos(data) {
    try {
      return await this.api.post('/pedidos', data);
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Pic-item ');
    }
  }

  async getPedidoById(id) {
    try {
      const { data } = await this.api.get(`/pedidos/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pic-item ');
    }
  }

  async createPedidoOperacao(data) {
    try {
      return await this.api.post('pedidos/salvarPedidoOperacao', data);
    } catch (error) {
      throw error;
    }
  }

  async createRascunhoOperacao(data) {
    try {
      return await this.api.post('pedidos/salvarRascunhoOperacao', data);
    } catch (error) {
      throw error;
    }
  }

  async putPedidosById(id, data) {
    try {
      const { data: response } = await this.api.put(`/pedidos/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pic-item ');
    }
  }

  async deletePedidosById(id) {
    try {
      const { data: response } = await this.api.delete(`/pedidos/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar pedido');
    }
  }

  async postPedidosSalvarPedidoCarrinho(data) {
    try {
      return await this.api.post('/pedidos/salvarPedidoCarrinho', data);
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao finalizar o pedido');
    }
  }

  async postPedidosSalvarRascunhoCarrinho(data) {
    try {
      return await this.api.post('/pedidos/salvarRascunhoCarrinho', data);
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao finalizar o rascunho');
    }
  }

  async updatePedidoHeader(id, data) {
    try {
      return await this.api.put(`/pedidos/${id}/atualizar-pedido`, data);
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao atualizar dados do pedido');
    }
  }

  // ── Fluxo de aprovação de doações (WD) — só Supervisor ──
  async getAprovacoesPendentes() {
    try {
      const { data } = await this.api.get('/pedidos/aprovacao/pendentes');
      return data;
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao listar doações pendentes de aprovação');
    }
  }

  async getLogsAprovacao(pedidoid) {
    try {
      const { data } = await this.api.get(`/pedidos/aprovacao/${pedidoid}/logs`);
      return data;
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao buscar logs de aprovação');
    }
  }

  async getDetalhesAprovacao(pedidoid) {
    try {
      const { data } = await this.api.get(`/pedidos/aprovacao/${pedidoid}/detalhes`, { timeout: 15000 });
      return data;
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao consultar a doação');
    }
  }

  async rejeitarPedidoDoacao(pedidoid, motivo) {
    try {
      const { data } = await this.api.post(`/pedidos/aprovacao/${pedidoid}/rejeitar`, { motivo }, { timeout: 30000 });
      return data;
    } catch (error) {
      if (!error.response) {
        throw new Error('Não foi possível confirmar o resultado. A rejeição pode ter sido processada; atualize a lista e consulte os logs antes de tentar novamente.');
      }
      throw this.error.messageCustom(error, 'Não foi possível rejeitar a doação');
    }
  }

  async aprovarPedidoDoacao(pedidoid) {
    try {
      const { data } = await this.api.post(`/pedidos/aprovacao/${pedidoid}/aprovar`);
      return data;
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao aprovar pedido de doação');
    }
  }
}
